import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, HStack, VStack, Spacer, Text, Image } from '@chakra-ui/react';
import { isTimeDue } from 'utils/dynDateUtils';
import { getImageUrl } from 'utils/ImageImporter';

function EssayCard({
  id,
  title,
  essayType,
  status,
  url,
  dueDate,
  score,
  finished,
}) {
  // console.log(id, title, essayType, status, url, dueDate, score);
  const navigate = useNavigate();

  function handleCardClick() {
    // console.log('card is clicked, the key: ', id);
    const returnUrl = finished
      ? `/student-profile/essay`
      : `/student-profile/assignment`;
    navigate(`/writing-practice/${id}/brainstorming?returnUrl=${returnUrl}`);
  }

  function capitalizeType(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1) + ' Writing';
  }
  return (
    <Box
      // key={key}
      borderRadius="md"
      overflow="hidden"
      boxShadow="md"
      borderWidth="1px"
      maxW={{ base: 'none', md: 'sm' }}
      w="full"
      cursor="pointer"
      onClick={handleCardClick}
    >
      {/* Upper Part: Image */}
      <Box position="relative" w="100%" pt="66%">
        {' '}
        {/* 3:2 Aspect Ratio */}
        <Image
          src={getImageUrl(url || essayType)}
          alt={title}
          position="absolute"
          top="0"
          left="0"
          w="100%"
          h="100%"
          objectFit="cover"
          transition="0.3s ease-in-out"
          _hover={{
            transform: 'scale(1.05)',
          }}
        />
      </Box>

      {/* Bottom Part: Content */}
      <VStack align="start" p={4} spacing={1}>
        <Text
          fontWeight="bold"
          fontSize="sm"
          display="-webkit-box"
          overflow="hidden"
          sx={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
          lineHeight="1.2"
        >
          {title}
        </Text>
        {finished ? (
          <HStack w="100%">
            <Text fontSize="sm" color="gray.600">
              {capitalizeType(essayType)}
            </Text>
            <Spacer />
            <Text fontSize="sm" color="gray.600">
              Score: {score}
            </Text>
          </HStack>
        ) : (
          <HStack w="100%">
            <Text fontSize="sm" color="gray.600">
              {status}
            </Text>
            <Spacer />
            <Text
              fontSize="sm"
              color={isTimeDue(dueDate) ? 'red.500' : 'blue.500'}
            >
              Due: {new Date(dueDate).toLocaleDateString()}
            </Text>
          </HStack>
        )}
      </VStack>
    </Box>
  );
}

EssayCard.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  essayType: PropTypes.string,
  status: PropTypes.string,
  url: PropTypes.string,
  dueDate: PropTypes.string,
  score: PropTypes.number,
  finished: PropTypes.bool,
};

export default EssayCard;
